import { useRef, useState } from 'react';
import ProgressBar, { ProgressBarHandle } from '../components/progress-bar';
import { ModalNotification } from '../components/modal';
import { useReviewStore } from '../stores/review';
import { Typography } from '../../../core/components/molecules/Typography';
import { Icon } from '../../../core/components/atoms/Icon';
import { formatTime } from '../../../core/commom/formatTime';
import { useNavigate } from 'react-router-dom';
import FlashcardReview from '../components/flashcard-review';
import { useMostraSeuAprovaTrigger } from '../../../core/components/organism/MostraSeuAprovaModal/useMostraSeuAprovaTrigger';

const ReviewFlashcard = () => {
  const { qtdFlashcards, qtdFlashcardsReviewed } = useReviewStore();

  const progressRef = useRef<ProgressBarHandle>(null);
  const [isOpenModalFinishReview, setIsOpenModalFinishReview] = useState(false);
  const [progressTime, setProgressTime] = useState(0);

  const onFinish = () => {
    const progressTime = progressRef.current?.stop();
    setProgressTime(typeof progressTime === 'number' ? progressTime : 0);
    setIsOpenModalFinishReview(true);
  };

  return (
    <div className='flex !h-[calc(100vh-240px)] w-full flex-col items-center justify-center px-6'>
      <FlashcardReview onFinish={onFinish} />
      <ProgressBar
        totalQuestions={qtdFlashcards}
        currentQuestion={qtdFlashcardsReviewed}
        ref={progressRef}
      />
      <ModalFinishReview
        isOpen={isOpenModalFinishReview}
        onClose={() => setIsOpenModalFinishReview(false)}
        progressTime={progressTime}
      />
    </div>
  );
};

export default ReviewFlashcard;

const ModalFinishReview = ({
  isOpen,
  onClose,
  progressTime,
}: {
  isOpen: boolean;
  onClose: () => void;
  progressTime: number;
}) => {
  const navigate = useNavigate();
  const { qtdFlashcards, setResetReview } = useReviewStore();
  const { fire: fireMostraSeuAprova } = useMostraSeuAprovaTrigger();

  const onCloseModal = () => {
    setResetReview();
    onClose();

    // Campanha #mostraseuaprova, só depois do "Parabéns": disparar junto com
    // ele deixaria os dois modais disputando a tela. O modal é global e
    // sobrevive à navegação abaixo. `fire` é no-op fora da campanha ou com o
    // aluno inelegível, e nunca lança.
    //
    // Sai junto com a campanha — ver
    // core/components/organism/MostraSeuAprovaModal/README.md.
    fireMostraSeuAprova('flashcards');

    navigate('/memory');
  };

  return (
    <ModalNotification
      isOpen={isOpen}
      onClose={onCloseModal}
      title='Parabéns, você finalizou sua revisão!'
    >
      <div className='flex flex-col gap-4'>
        <div className='flex flex-row gap-2'>
          <div className='flex flex-row items-center gap-2'>
            <Icon Icon='description' type='material' className='text-md' />
            <Typography className='text-h4 font-bold text-mono-color-darkest'>
              Total de <i>flashcards</i> revisados:
            </Typography>
          </div>
          <span className='text-md text-mono-color-darkest'>
            {qtdFlashcards}
          </span>
        </div>
        <div className='flex flex-row gap-2'>
          <div className='flex flex-row items-center gap-2'>
            <Icon Icon='timer' type='material' className='text-md' />
            <Typography className='text-h4 font-bold text-mono-color-darkest'>
              Tempo de revisão:
            </Typography>
          </div>
          <span className='text-md text-mono-color-darkest'>
            {formatTime(progressTime)}
          </span>
        </div>
      </div>
    </ModalNotification>
  );
};
